import {
  TOGGLE_COLLAPSED_NAV,
  SIDE_NAV_STYLE_CHANGE,
  CHANGE_LOCALE,
  NAV_TYPE_CHANGE,
  TOP_NAV_COLOR_CHANGE,
  HEADER_NAV_COLOR_CHANGE,
  TOGGLE_MOBILE_NAV,
  SWITCH_THEME,
  DIRECTION_CHANGE,
} from "../constants/Theme";

export function toggleCollapsedNav(navCollapsed) {
  localStorage.setItem("navCollapsed", navCollapsed);
  return {
    type: TOGGLE_COLLAPSED_NAV,
    navCollapsed,
  };
}

export function onNavStyleChange(sideNavTheme) {
  localStorage.setItem("sideNavTheme", sideNavTheme);
  return {
    type: SIDE_NAV_STYLE_CHANGE,
    sideNavTheme,
  };
}

export function onLocaleChange(locale) {
  localStorage.setItem("locale", locale);
  return {
    type: CHANGE_LOCALE,
    locale,
  };
}

export function onNavTypeChange(navType) {
  localStorage.setItem("navType", navType);
  return {
    type: NAV_TYPE_CHANGE,
    navType,
  };
}

export function onTopNavColorChange(topNavColor) {
  localStorage.setItem("topNavColor", topNavColor);
  return {
    type: TOP_NAV_COLOR_CHANGE,
    topNavColor,
  };
}

export function onHeaderNavColorChange(headerNavColor) {
  localStorage.setItem("headerNavColor", headerNavColor);
  return {
    type: HEADER_NAV_COLOR_CHANGE,
    headerNavColor,
  };
}

export function onMobileNavToggle(mobileNav) {
  localStorage.setItem("mobileNav", mobileNav);
  return {
    type: TOGGLE_MOBILE_NAV,
    mobileNav,
  };
}

export function onSwitchTheme(currentTheme) {
  localStorage.setItem("currentTheme", currentTheme);
  return {
    type: SWITCH_THEME,
    currentTheme,
  };
}

export function onDirectionChange(direction) {
  localStorage.setItem("direction", direction);
  return {
    type: DIRECTION_CHANGE,
    direction,
  };
}
